AgrimarketServices.service('unitService', ['$http', 'configurationFactory',
    function ($http, configurationFactory) {

        var SendRequest = function (configfile, callback) {
            $http(configfile)
                .success(function (data) {
                    callback(data, null);
                })
                .error(function (data, status) {
                    callback(data, status);
                });
        };

        this.GetAllUnits = function (callback) {
            var config = {
                method: 'GET',
                url: configurationFactory.Url['Api'] + 'Unit/GetAllUnits'
            };
            SendRequest(config, callback);
        };

    }]);